import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AppBarComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openDrawer, setOpenDrawer] = useState(false);
  const navigate = useNavigate();

  // Centralized nav items
  const navItems = [
    { label: "Home", route: "/home" },
    { label: "Add", route: "/add" },
    { label: "Estimate", route: "/estimate" },
    { label: "Document", route: "/document" },
    { label: "จัดการสมาชิก", route: "/members" },
    { label: "ตั้งค่าพารามิเตอร์", route: "/setupparameter" },
    { label: "Logout", action: () => handleLogout() },
  ];

  // Logout handler
const handleLogout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");

  window.location.replace("/login");
};


  // Navigation click handler
  const handleNavClick = (item) => {
    item.action ? item.action() : item.route && navigate(item.route);
  };

  // Common button style
  const navButtonStyle = {
    minWidth: 100,
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "20px",
    color: "#000",
    backgroundColor: "#C8EAE6",
    border: "2px solid #fff",
    mx: 0.5,
  };

  return (
  <>
    {/* Sticky Header (รวม 2 แถบ) */}
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      {/* Top AppBar */}
      <AppBar
        position="static"
        sx={{
          height: 50,
          backgroundColor: "#1B1F50",
        }}
      >
        <Toolbar sx={{ height: "100%", minHeight: "60px !important" }}>
          <Typography
            variant="h5"
            sx={{
              flexGrow: 1,
              textAlign: "center",
              fontSize: isMobile ? "1rem" : "1.5rem",
            }}
          >
            แอปพลิเคชันการประเมินราคาและระยะเวลาในการพัฒนาซอฟต์แวร์
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Second Nav Bar */}
      <Box sx={{ display: "flex", height: 60, width: "100%" }}>
        {/* Left: Mobile Menu */}
        {isMobile && (
          <Box
            sx={{
              flex: 1,
              bgcolor: "#368D83",
              display: "flex",
              alignItems: "center",
              pl: 1,
            }}
          >
            <IconButton
              onClick={() => setOpenDrawer(true)}
              sx={{ color: "#fff" }}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="left"
              open={openDrawer}
              onClose={() => setOpenDrawer(false)}
            >
              <List sx={{ width: 200 }}>
                {navItems.map((item) => (
                  <ListItem
                    button
                    key={item.label}
                    onClick={() => {
                      setOpenDrawer(false);
                      handleNavClick(item);
                    }}
                  >
                    <ListItemText primary={item.label} />
                  </ListItem>
                ))}
              </List>
            </Drawer>
          </Box>
        )}

        {/* Center: Desktop Menu */}
        {!isMobile && (
          <Box
            sx={{
              flexGrow: 1,
              maxWidth: "80%",
              bgcolor: "#C8EAE6",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: 3,
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.label}
                variant="contained"
                size="small"
                sx={navButtonStyle}
                onClick={() => handleNavClick(item)}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}

        {/* Right side filler */}
        <Box sx={{ flex: 1, bgcolor: "#368D83" }} />
      </Box>
    </Box>
  </>
);

};

export default AppBarComponent;
